<template>
  <div>
    <!-- <v-btn color="primary" dark class="mb-2 hbtn" to="/events/create">New</v-btn> -->
    <DataTable
      :url="api.ACTIONS.EVENTS"
      :titles="titles"
      :fields-hidden-main="['deleted_at', 'updated_at']"
      :fields-hidden-add="['id', 'deleted_at', 'created_at', 'updated_at']"
      :fields-hidden-edit="[
        'deleted_at',
        'created_at',
        'updated_at',
        'registered_drivers',
      ]"
      :formatter="formatters"
      :title="$t('planningPage.eventsTitle')"
      sortBy="start_date"
      :enableAdd="false"
      
      :actions-extra-main="actionsExtraMain"
      :fieldsDisabledEdit="[
        'created_at',
        'deleted_at',
        'updated_at',
        'id',
        'start_date',
        'end_date',
        'name',
        'registered_drivers',
      ]"
    />
  </div>
</template>

<style>
.hbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import { companyToday, formatCompanyTime } from "@/util/companyTime";

const required = (val) =>
  (val !== null && val !== undefined) || "this field is required";
const email = (val) =>
  (!!val && val.search(/^(\w|-|\.|_)+@(\w|-|\.|_)+\.\w+$/) !== -1) ||
  "this must be a valid email";
const past = (val) =>
  (!!val && moment(val).format("YYYY-MM-DD") < companyToday()) ||
  "this must be past date";

export default {
  name: "Events",
  title() {
    return this.$t("planningPage.eventsTitle");
  },
  components: { DataTable },
  data() {
    return {
      permission: null,
      formatters: {
        created_at(value) {
          return formatCompanyTime(value, " DD MMM YYYY");
        },
      },
    };
  },

  computed: {
    // par() {
    //   const par = new URLSearchParams();
    //   par.append("sortBy", "start_date");
    //   return par;
    // },
    titles() {
      return {
        id: this.$t("planningPage.id"),
        name: this.$t("planningPage.eventName"),
        start_date: this.$t("planningPage.startDate"),
        end_date: this.$t("planningPage.endDate"),
        last_appliance_date: this.$t("planningPage.lastApplianceDateCol"),
        registered_drivers: this.$t("planningPage.registeredDrivers"),
        created_at: this.$t("planningPage.creationDate"),
      };
    },
    created() {
      console.log('permission');
      // console.log(this.$store.state.user);
      // this.permission = this.$store.state.user.roles[0].name;
    },
    actionsExtraMain() {
      return {
        info: {
          title: this.$t("planningPage.info"),
          icon: "info",
          action: (item) =>
            this.$router.push({
              name: "EventDetails",
              params: { id: item.id },
            }),
        },
      };
    },
  },
  methods: {},
};
</script>
